module.exports = __webpack_public_path__ + "static/media/galerija_2013 (5).abbb9f44.jpg";